import { useState, useEffect, useMemo } from "react";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const memoizedWindowSize = useMemo(() => windowSize, [windowSize.width, windowSize.height]);

  return memoizedWindowSize;
}

export default useWindowSize;